import { render, staticRenderFns } from "./OrderDetailComponent.vue?vue&type=template&id=98a012b8&scoped=true"
import script from "./OrderDetailComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailComponent.vue?vue&type=style&index=0&id=98a012b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a012b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a012b8')) {
      api.createRecord('98a012b8', component.options)
    } else {
      api.reload('98a012b8', component.options)
    }
    module.hot.accept("./OrderDetailComponent.vue?vue&type=template&id=98a012b8&scoped=true", function () {
      api.rerender('98a012b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/sanjiang/OrderDetailComponent.vue"
export default component.exports